<template>
  <div class="ts-form-item" :class="{ error: hasError }">
    <div v-if="label" :style="{ 'margin-bottom': `${offset - 4}px` }" class="label">{{ label }}</div>
    <slot></slot>
    <div class="error-message" :style="{ bottom: `-${offset}px` }" v-if="hasError">{{ errorMessage }}</div>
  </div>
</template>

<style lang="scss" scoped>
.ts-form-item::v-deep {
  width: 100%;
  position: relative;

  .label {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .error-message {
    position: absolute;
    left: 15px;
    bottom: -4px;
    font-family: Roboto;
    font-size: 12px;
    color: #f56c6c;
  }

  .ts-input,
  .ts-dropdown-button {
    margin: 12px 0;
  }

  &.error {
    button.ts-button,
    .ts-input input,
    .ts-input textarea,
    .ts-dropdown button,
    .ts-select input {
      border-color: #f56c6c;
    }
  }
}
</style>

<script>
export default {
  name: 'TsFormItem',
  props: {
    validation: {
      type: Object,
      default: null
    },
    offset: {
      type: Number,
      default: 4
    },
    label: {
      type: String,
      default: null
    }
  },
  computed: {
    hasError() {
      return this.validation && this.validation.$error;
    },
    errorMessage() {
      if (this.validation) {
        for (const [validationName, validationParams] of Object.entries(this.validation.$params)) {
          if (!this.validation[validationName]) {
            const type = validationParams?.type || validationName;
            switch (type) {
              case 'required':
              case 'requiredIf':
                return 'Field is required';
              case 'email':
                return 'Field should be a valid email';
              case 'minLength':
                return `Field should be at least ${validationParams.min} characters`;
              case 'sameAs':
                return `Field should match ${validationParams.eq}`;
              case 'isUniqueUsername':
                return 'An account with this email already exists';
              case 'url':
                return 'Field should be a valid URL';
            }
          }
        }
      }
      return '';
    }
  }
};
</script>
